import React from "react";
import logger from "logger";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Ripple from "react-material-ripple";
import "./index.css";

export default function(props) {
  return (
    <Ripple>
      <Card
        className="enlargeonhover taskletcard"
        onClick={props.onClick}
        style={{
          width: "auto",
          height: "auto",
          padding: "5px 20px 20px 20px",
          margin: "20px",
        }}
      >
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            <span style={{ textTransform: "uppercase" }}>{props.title}</span>
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            <span style={{ textTransform: "uppercase" }}>{props.desc}</span>
          </Typography>
        </CardContent>
      </Card>
    </Ripple>
  );
}
